import { useContext } from 'react';
import styled, { ThemeContext } from 'styled-components';
import {
    Popover,
    Menu,
    MenuItem,
    Position,
    Button,
    MenuDivider,
    Classes, Tag,
} from '@blueprintjs/core';
import defaultLogo from '../../styles/logos/mobile-dashboard-logo.png';
import history from '../../root/history';
import {AVL_ENVIRONMENT} from "../../config/vars";
import { MY_REPORTS, AI_REPORTS, AI_CHAT } from '../../constants/routes';

const Wrapper = styled.section`
  width: 100%;
  background: var(--mobile-header-background);
  color: var(--mobile-header-text);
  flex: 1;
  order: -1;
  padding: 1em;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;
const LogoImg = styled.img`
  max-width: 180px;
  max-height: 30px;
`;
const BoldMenuItem = styled(MenuItem)`
  font-weight: 600;

  & div {
    color: rgb(24, 32, 38);
  }
`;

const MobileSidebar = ({ user = {}, logout, productMenuItems, location }) => {
  const theme = useContext(ThemeContext);
  const logo =
    theme && theme.logo && theme.logo.mobile
      ? `../assets/logos/${theme.logo.mobile}`
      : defaultLogo;

  // Check if an item is selected based on current path
  const isItemSelected = (item) => {
    if (typeof window !== 'object') return false;
    const currentPath = window.location.pathname;
    
    // Exact match items only match on exact path
    if (item.exactMatch) {
      return item.path === currentPath;
    }
    
    // Accordions are selected if any child matches
    if (item.isAccordion && item.children && item.children.length > 0) {
      return item.children.some((child) => currentPath === child.path);
    }
    
    // Default: match on path
    return item.path === currentPath;
  };

  const activeItem = productMenuItems.find((item) => isItemSelected(item));

  const productMenu = (
    <Menu>
      <BoldMenuItem icon="user" disabled={true} text={user.name} />
      <MenuItem icon="office" disabled={true} text={user.organisationName} />
      <MenuDivider />
      {productMenuItems.map((item, index) => (
        <MenuItem
          icon={item.icon}
          key={item.path || item.label || index}
          text={item.label}
          location={location}
          onClick={(e) => {
            if (item.path.includes('https://')) {
              window.location = item.path;
            } else if (item.isAccordion && item.children && item.children.length > 0) {
              // For accordions, navigate to first child (skip AI_REPORTS for My Reports)
              const navigableChildren = item.path === MY_REPORTS
                ? item.children.filter(child => child.path !== AI_REPORTS)
                : item.children;
              
              if (navigableChildren.length > 0) {
                history.push(navigableChildren[0].path);
              } else if (item.path === MY_REPORTS) {
                // Only "Create report with AI" exists, navigate to AI Reports
                history.push(AI_REPORTS);
              } else {
                // Fallback to accordion's path
                history.push(item.path);
              }
            } else {
              history.push(item.path);
            }
          }}
          disabled={isItemSelected(item)}
        />
      ))}
      <MenuItem icon="log-out" text="Logout" onClick={logout} />
    </Menu>
  );

  return (
    <Wrapper>
      <LogoImg src={logo} alt="Aura Vision Labs logo" />
        {AVL_ENVIRONMENT !== "prod" &&
            <Tag
                large
                intent={AVL_ENVIRONMENT === "uat"? "warning" : "danger"}
                style={{textAlign: "center"}}>
                {AVL_ENVIRONMENT === "uat"? "UAT" : "RISK UNKNOWN ENVIRONMENT"}
            </Tag>
        }
      <div>{activeItem && activeItem.label}</div>
      <Popover content={productMenu} position={Position.BOTTOM_LEFT}>
        <Button icon="menu" className={Classes.MINIMAL} />
      </Popover>
    </Wrapper>
  );
};

export default MobileSidebar;
